var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountBannerArrowSns = function SvgAccountBannerArrowSns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0054A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.75,
    d: "M33 18H3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.6,
    d: "M10.637 10.364 3 18l7.637 7.636"
  }))));
};
export default SvgAccountBannerArrowSns;